import { HelpIcon } from '@dixa/lib-shared-habla';

import Spinner from '../../ajax/components/Spinner';

import './styles/input-field.less';

type PropsT = {
  id: string | null;
  name: string | null;
  displayName: string;
  style?: any;
  type: string;
  disabled: string | null;
  hidden: string | null;
  required: boolean | null;
  placeholder: string | null;
  showSpinner: boolean | null;
  className: string | null;
  showHelpIcon: boolean | null;
  helpIconTitle: string | null;
  helpIconText: string | null;
  onChangeAction: ((e: any) => void) | null;
  onBlurAction: ((e: any) => void) | null;
  min: string | null;
  autoFocus: boolean | null;
  step: string | null;
  max: string | null;
  maxLength: string | null;
  fieldId: string | null;
} & any;

const InputField = ({
  displayName,
  style,
  type,
  disabled,
  hidden,
  required,
  placeholder,
  input,
  meta,
  showSpinner,
  className,
  showHelpIcon,
  helpIconTitle,
  helpIconText,
  onChangeAction,
  onBlurAction,
  onKeyDownAction,
  min,
  step,
  max,
  maxLength,
  autoFocus,
  hasPrefix,
}: PropsT) => {
  const setFous = autoFocus ? autoFocus : false;

  const name = input.name;
  let formGroupClasses =
    className && typeof className === 'string' ? className : '';
  let isDisabled = '';
  let validationErrors: JSX.Element | null = null;
  let isRequired: string | null = null;
  let spinner: JSX.Element | null = null;
  let helpIcon: JSX.Element | null = null;
  let placeholderValue = '';
  let prefix: JSX.Element | null = null;
  if (meta && meta.touched === true && meta.valid === true) {
    formGroupClasses += ' has-success';
  } else if (meta && meta.touched === true && meta.error) {
    formGroupClasses += ' has-error';
    validationErrors = <span className="validation-text">{meta.error}</span>;
  }
  if (meta && meta.active === true) {
    formGroupClasses += ' focused';
  }

  if (hidden === true) {
    formGroupClasses += ' hidden';
  }

  if (disabled === true) {
    formGroupClasses += ' disabled';
    isDisabled = 'disabled';
  }

  if (placeholder === null || placeholder === undefined) {
    placeholderValue = displayName + '...';
  } else {
    placeholderValue = placeholder;
  }

  if (required === true) {
    isRequired = 'required';
  }

  if (showSpinner === true) {
    spinner = <Spinner className="dark input" />;
  }

  if (showHelpIcon === true) {
    helpIcon = (
      <span className="helpIcon">
        <HelpIcon text={helpIconText} title={helpIconTitle} />
      </span>
    );
  }

  if (hasPrefix) {
    prefix = (
      <span className="input-group-addon">
        <b>https://</b>
      </span>
    );
  }

  return (
    <div className={`form-group ${formGroupClasses}`} style={style}>
      {displayName !== '' && (
        <label className="control-label" htmlFor={name}>
          {displayName} {required === true ? '*' : ''} {validationErrors}
        </label>
      )}
      {helpIcon}
      <div className="input-group">
        {prefix}
        <input
          id={name}
          value={input.value}
          autoFocus={setFous}
          onBlur={(e: any) => {
            input.onBlur(e);
            if (typeof onBlurAction === 'function') {
              onBlurAction(e);
            }
          }}
          onFocus={(e: any) => {
            input.onFocus(e);
          }}
          checked={input.checked}
          onChange={(e: any) => {
            if (typeof onChangeAction === 'function') {
              onChangeAction(e);
            }
            input.onChange(e);
          }}
          onKeyDown={(e: any) => {
            if (typeof onKeyDownAction === 'function') {
              onKeyDownAction(e);
            }
          }}
          min={min}
          max={max}
          step={step}
          maxLength={maxLength}
          required={isRequired as any}
          disabled={isDisabled as any}
          className="form-control"
          type={type}
          placeholder={placeholderValue}
        />
      </div>
      {spinner}
    </div>
  );
};
export default InputField;
